import 'bootstrap';
import 'bootstrap-accessibility-plugin';

import 'angular';
// Typescript modules are executed within their own scope, not in global scope.
// Require in js file to add it to global scope in order for angular-auth0 to access auth0.
import './requireAuth0.js';
import '../../../node_modules/angular-auth0/';

import 'angular-storage';
import 'angular-route';
import 'angular-jwt';
import 'angular-scroll';
import 'angular-cookies';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'angular-ui-bootstrap';
import 'angular-ui-router';
import 'angular-marked';
import 'angular-drag-and-drop-lists';
import 'angular-file-upload';
import 'angular-resource';

import { QuestionnaireResolver } from './QuestionnaireResolver';
import { IQuestionnaireService } from './services/QuestionnaireService';
import { ITranslationService }   from './services/TranslationService';
import { ErrorService } from './services/ErrorService';

import moment = require('moment/moment');

// Register environment in AngularJS as constant to make available across app by injecting luminaQuestionnaireConfig into our modules,
angular.module('luminaQuestionnaireConfig', []).constant('luminaEnv', __env);

export let app = angular.module('LuminaQuestionnaire', [
    'angular-storage',
    'angular-jwt',
    'ngRoute',
    'duScroll',
    'ngCookies',
    'pascalprecht.translate',
    'ui.bootstrap',
    'ui.router',
    'hc.marked',
    'dndLists',
    'angularFileUpload',
    'luminaQuestionnaireConfig',
    'luminaQuestionnaireServices',
    'auth0.auth0',
]);

app.constant('QUESTION_TYPES_COMPONENTS', {
    maxSecondClickPopovers: 10
});

app.config([
    '$interpolateProvider',
    '$stateProvider',
    '$urlRouterProvider',
    '$httpProvider',
    '$locationProvider',
    '$compileProvider',
    '$qProvider',
    '$windowProvider',
    'jwtInterceptorProvider',
    'jwtOptionsProvider',
    '$translateProvider',
    'markedProvider',
    'angularAuth0Provider',
    'luminaEnv',
    'authServiceProvider',
    function ($interpolateProvider:ng.IInterpolateProvider,
              $stateProvider:any,
              $urlRouterProvider:any,
              $httpProvider:ng.IHttpProvider,
              $locationProvider:ng.ILocationProvider,
              $compileProvider:ng.ICompileProvider,
              $qProvider:any,
              $windowProvider:any,
              jwtInterceptorProvider:IJwtInterceptor,
              jwtOptionsProvider:any,
              $translateProvider:angular.translate.ITranslateProvider,
              markedProvider:any,
              angularAuth0Provider:any,
              luminaEnv:any,
              authServiceProvider:any) {

        // @TODO: should start components and controllers using $ngInit instead of construct!
        // $compileProvider.preAssignBindingsEnabled(true);
        $qProvider.errorOnUnhandledRejections(false);

        $interpolateProvider.startSymbol('<%');
        $interpolateProvider.endSymbol('%>');

        // Reveal internal state representation, note this won't be needed once we upgrade to uirouter 1.0
        // https://github.com/angular-ui/ui-router/issues/1651
        $stateProvider.decorator('parent', function (internalStateObj, parentFn) {
            internalStateObj.self.$$state = function () {
                return internalStateObj;
            };
            return parentFn(internalStateObj);
        });

        $stateProvider
            .state('welcome', {
                url        : '/',
                templateUrl: 'templates/home.html',
                controller : 'HomeController',
            })
            .state('loginCallback', {
                url        : '/loginCallback?returnUrl',
                templateUrl: 'templates/loginCallback.html',
                controller : 'LoginCallbackController',
            })
            .state('login', {
                url        : '/login?returnUrl',
                templateUrl: 'templates/login.html',
                controller : 'LoginController',
            })
            .state('logout', {
                url        : '/logout',
                templateUrl: 'templates/logout.html',
                controller : 'LogoutController',
                data       : {
                    requiresLogin: true
                },
            })
            .state('questionnaireSelf', {
                url           : '/questionnaire/:slug/:upid?exit-redirect',
                templateUrl   : 'templates/session.html',
                resolve       : {
                    questionnaire: QuestionnaireResolver
                },
                controller    : 'SessionController',
                controllerAs  : 'session',
                reloadOnSearch: false,
                data          : {
                    requiresLogin: true
                },
            })
            .state('questionnaire360', {
                url           : '/questionnaire/:slug/:upid/:raterGuid?exit-redirect',
                templateUrl   : 'templates/session.html',
                resolve       : {
                    questionnaire: QuestionnaireResolver
                },
                controller    : 'SessionController',
                controllerAs  : 'session',
                reloadOnSearch: false,
                data          : {
                    requiresLogin: true
                },
            });

        $urlRouterProvider.otherwise('/');

        $locationProvider.hashPrefix('!');
        $locationProvider.html5Mode(true);

        // Auth0
        authServiceProvider.init();

        jwtOptionsProvider.config({
            tokenGetter              : function () {
                // This is what determines if we are logged in or not
                return localStorage.getItem('id_token');
            },
            // We need to add any external domains here which we want our auth token to be sent to
            whiteListedDomains       : luminaEnv.whiteListedDomains,
            // Redirect to login on states with requiresLogin: true
            unauthenticatedRedirector: [
                '$state', function ($state) {
                    // Do nothing here now, moved to auth service for SSO
                    // In locationChangeStart
                }
            ]
        });


        //Push interceptor function to $httpProvider's interceptors
        $httpProvider.interceptors.push('jwtInterceptor');

        // Interceptor that shows a message if an error occurred
        $httpProvider.interceptors.push([
            '$q', 'ErrorService', '$injector',
            ($q:ng.IQService, errorService:ErrorService) => {

                let noConnectionRetries = 0;

                return {
                    responseError: (response) => {
                        const status = response.status;
                        //GH status for timeout and no connection is -1 - FF throws this in first request always
                        //Now we are going to allow this twice without showing the error dialog.
                        if (status === -1 && noConnectionRetries < 2) {
                            console.log('no connection - silent fail ' + noConnectionRetries);
                            noConnectionRetries++;  //never clear the counter
                            return $q.reject(response);
                        }

                        if ((status < 100) || (status > 422 && status < 600)) { //401 400 404 422 are valid server responses
                            errorService.httpError(response);
                            return $q.reject(response);
                        }

                        // otherwise
                        return response;
                    }
                };
            }
        ]);

        $translateProvider
            .useLocalStorage()
            .useStaticFilesLoader({
                prefix: '/api/translator/',
                suffix: '/web-client-ui'
            })
            .preferredLanguage('en-GB')
            .fallbackLanguage('en-GB')
            .useSanitizeValueStrategy('escapeParameters')
            .storageKey('locale');

        // Moment
        moment.fn.toJSON = function () {
            return this.utc().format('YYYY-MM-DD HH:mm:ss');
        };

        // Marked
        markedProvider.setOptions({
            gfm   : true,
            tables: true
        });

        markedProvider.setRenderer({
            link: function (href, title, text) {
                return '<a href="' + href + '"' + (title ? ' title="' + title + '"' : '') + ' target="_blank">' + text + '</a>';
            }
        });

    }
]);

app.run([
    '$rootScope', 'authService', 'luminaEnv',
    function ($rootScope, authService, luminaEnv) {
        let ssoClient =  document.getElementById('sso-iframe');
        ssoClient.setAttribute('src', luminaEnv.ssoV2Url + '/auth-frame');

        authService.setupKeycloakSso();
        
        // Register the synchronous hash parser
        // when using UI Router
        authService.interceptHash();

        // Run authManager's run section
        authService.runAuthManager();

    }
]);


import './libraries/libraries';
import './sharedQuestions/sharedQuestions';
import './directives/directives';
import './services/services';
import './filters/filters';
import './components/components';
import './controllers/controllers';
import Questionnaire from '../../../app/Libraries/ScriptExecutor/Modules/Questionnaire';
